import { default as _last } from "lodash/last";

export const PERIODS_OPTIONS_TEMPLATE = {
  options: {
    timeframe: {
      start: null,
      type: null,
    },
    timerange: null,
    periods_to_show: null,
    timezone: null,
  },
};

const usePeriodsWithTimeRangeExplorer = ({
  optionsProxy,
  updateOptionsProxy,
  periods,
  getWindowOffsetStart,
}) => {
  const {
    timeframe = {},
    timerange,
    timezone,
    periods_to_show: periodsToShow = 0,
  } = optionsProxy?.options ?? {};

  const _moveWindow = (direction) => {
    const dtvalue = getWindowOffsetStart(
      direction * Math.max(periodsToShow - 1, 1),
    );
    const newTimeframe = {
      ...timeframe,
      type: "fixed",
      start: dtvalue,
    };
    updateOptionsProxy(
      {
        options: {
          ...optionsProxy.options,
          timeframe: newTimeframe,
        },
      }
    );
  };

  const showPrevious = () => _moveWindow(-1);
  const showNext = () => _moveWindow(1);

  const adjustStartTime = (offset) => {
    return getWindowOffsetStart(offset);
  }

  const setOptions = (options) => {
    // map explorer options to widget options
    const periodsToShow = options.periodsToShow;
    const timerange = options.timerange;
    const timeframeType = options.timeframeType;
    const startDate = options.startDate;
    const optionUpdates = {};
    const timeframeUpdates = {};
    if (periodsToShow) {
      optionUpdates.periods_to_show = periodsToShow;
    }
    if (timerange) {
      optionUpdates.timerange = timerange;
    }
    if (timeframeType) {
      timeframeUpdates.type = timeframeType;
    }
    if (startDate) {
      timeframeUpdates.start = startDate;
    }
    updateOptionsProxy(
      {
        options: {
          ...optionsProxy.options,
          ...optionUpdates,
          timeframe: { ...timeframe, ...timeframeUpdates },
        },
      }
    );
  };

  return {
    options: {
      periodsToShow,
      timerange,
      timeframeType: timeframe.type,
      startDate:
        timeframe?.type !== "fixed"
          ? _last(periods)?.startValue
          : timeframe?.start,
      endDate: periods?.[0]?.endValue,
      timezone: timezone,
    },
    timerangesSupported: ["shift", "day", "week", "month"],
    setOptions,
    showPrevious,
    showNext,
    adjustStartTime,
  };
};

export default usePeriodsWithTimeRangeExplorer;
